import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import LightTypography from '../LightTypography';

function TitleBar({ steps }) {
  const titleBar = steps.map((step, idx) => {
    const GTsign = idx !== steps.length - 1 ? '>' : '';
    return (
      <Box
        alignSelf="flex-end"
        key={step}
        // p={1}
      >
        <LightTypography>
          {step + GTsign}
        </LightTypography>
      </Box>

    );
  });
  return (
    <Box
      display="flex"
      flexDirection="row"
    >
      {titleBar}
    </Box>

  );
}

TitleBar.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.string),
};

TitleBar.defaultProps = {
  steps: [],
};

export default TitleBar;
